import dayjs from "dayjs";

export const localTime = function(date) {
  if (date) {
    let formateForSafari = dayjs(date).format("YYYY/MM/DD HH:mm:ss");
    let utcDate = formateForSafari + " UTC";
    return dayjs(utcDate).format("HH:mm");
  } else {
    return dayjs().format("HH:mm");
  }
};

var URI = require("urijs");
export const checkUri = function(source) {
  // console.log("source", source);
  let content = URI.withinString(source, function(url) {
    return `<a href="${url}" target="_blank" rel="noreferrer noopener">${url}</a>`;
  });

  return content;
};
